import { FC, useMemo, useState } from 'react';

import { Modal } from '@smartshell/ui-kit';

import { EVerificationType } from 'types';

import {
  ChangeVerifyMethod,
  OutGoingCallVerify,
  VerifyCode,
} from './components';
import { IVerifyModalProps } from './interfases';
import s from './Verify.module.scss';

export const VerifyModal: FC<IVerifyModalProps> = ({
  onClose,
  phone,
  email,
  onPhoneChange,
  verification,
  verificationType,
  setVerificationType,
  notValidMethod,
  setNotValidMethod,
  setVerification,
  setOnSuccess,
  ...props
}) => {
  const [isChangeMethod, setIsChangeMethod] = useState(false);

  const VariantModal = useMemo(() => {
    if (isChangeMethod)
      return (
        <ChangeVerifyMethod
          phone={phone}
          setIsChangeMethod={setIsChangeMethod}
          setVerificationType={setVerificationType}
          notValidMethod={notValidMethod}
          setNotValidMethod={setNotValidMethod}
          email={email}
        />
      );

    if (verification) {
      switch (verificationType) {
        case EVerificationType.OUTGOING_CALL:
          return (
            <OutGoingCallVerify
              phone={phone}
              call_number={verification.call_number}
              setIsChangeMethod={setIsChangeMethod}
              onPhoneChange={onPhoneChange}
              verification_id={verification.verification_id}
              setVerification={setVerification}
              setOnSuccess={setOnSuccess}
            />
          );
        default:
          return (
            <VerifyCode
              {...props}
              phone={phone}
              email={email}
              verificationType={verificationType}
              setVerification={setVerification}
              setOnSuccess={setOnSuccess}
              onPhoneChange={onPhoneChange}
              verification={verification}
            />
          );
      }
    }

    return null;
  }, [isChangeMethod, verification, verificationType]);

  return (
    <Modal onClose={onClose} className={s.modal} disableOutsideClose>
      {VariantModal}
    </Modal>
  );
};
